import { useRef } from 'react';
import ChartsInfiniteList from './chartsInfiniteList';
import ListPageLayout from '../utils/ListPageLayout';

function ChartsPage() {
  const updateQueryFunc = useRef(null);

  return (
    <>
      <ListPageLayout
        title="Charts"
        tagline="Reference charts and informational explanations."
        sidebar={null}
      >
        <ChartsInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default ChartsPage;
